import "../pages.scss"
import { ArticulosState } from '../../context/articulos/ArticulosState';
import Datatable from "./articulosTable/Datatable"

const ArticulosPage = () => {
  return (
    <>
      <ArticulosState>
        <Datatable />
      </ArticulosState>

    </>
  )
}

export default ArticulosPage